// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NnLgq{min-height:calc(100vh - var(--anchore-page-offset-bottom))}.NnLgq .ySxEW{position:fixed!important}.NnLgq .ySxEW>div{align-items:center!important;display:flex!important;flex-direction:column!important;height:100%!important;justify-content:center!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NnLgq`,
	"pageDimmer": `ySxEW`
};
module.exports = ___CSS_LOADER_EXPORT___;
